import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, createBlock as _createBlock, normalizeStyle as _normalizeStyle, Fragment as _Fragment } from "vue";
var _hoisted_1 = {
  style: {
    "overflow": "auto",
    "position": "relative",
    "max-width": "900px",
    "margin": "0 auto"
  }
};
var _hoisted_2 = {
  key: 0,
  class: "scale-controls"
};
var _hoisted_3 = {
  style: {
    "margin": "0 10px"
  }
};
var _hoisted_4 = {
  key: 0,
  class: "pdf-container"
};
var _hoisted_5 = {
  key: 0,
  class: "pagination"
};
var _hoisted_6 = {
  style: {
    "margin": "0 15px"
  }
};
var _hoisted_7 = {
  key: 2,
  class: "excel-preview-wrapper"
};
var _hoisted_8 = {
  key: 3,
  style: {
    "width": "100%",
    "height": "100%",
    "display": "flex",
    "align-items": "center",
    "justify-content": "center"
  }
};
var _hoisted_9 = ["src"];
var _hoisted_10 = {
  key: 4,
  style: {
    "text-align": "center",
    "padding": "50px"
  }
};
var _hoisted_11 = {
  key: 1,
  style: {
    "text-align": "center",
    "padding": "50px"
  }
};
var _hoisted_12 = {
  class: "dialog-footer"
};
var _hoisted_13 = {
  key: 0,
  style: {
    "position": "absolute",
    "bottom": "15px",
    "left": "50%",
    "transform": "translateX(-50%)",
    "z-index": "10",
    "background": "rgba(0, 0, 0, 0.6)",
    "padding": "5px 15px",
    "border-radius": "20px",
    "display": "flex",
    "align-items": "center"
  }
};
var _hoisted_14 = {
  style: {
    "color": "white",
    "margin": "0 10px"
  }
};
var _hoisted_15 = {
  style: {
    "text-align": "center"
  }
};
var _hoisted_16 = ["src"];
import { ref, watch, computed, onUnmounted } from "vue";
import VueOfficePdf from "@vue-office/pdf";
import VueOfficeDocx from "@vue-office/docx";
import VueOfficeExcel from "@vue-office/excel";
import "@vue-office/excel/lib/index.css";
import { ElMessage } from "element-plus";
import VuePdfEmbed from "vue-pdf-embed";
export default {
  __name: 'FilePreviewDialog',
  props: {
    modelValue: {
      type: Boolean,
      default: false
    },
    file: {
      type: [Object, Array],
      default: () => ({})
    },
    title: {
      type: String,
      default: "文件预览"
    }
  },
  emits: ["update:modelValue"],
  setup(__props, _ref) {
    var {
      emit: __emit
    } = _ref;
    var props = __props;
    var emit = __emit;
    var visible = computed({
      get: () => props.modelValue,
      set: val => emit("update:modelValue", val)
    });
    var loading = ref(false);
    var fileList = ref([]);
    var currentFileIndex = ref(0);
    var currentPage = ref(1);
    var totalPages = ref(0);
    var scale = ref(1.0);
    var zoomIn = () => {
      if (scale.value < 2) {
        scale.value = Math.min(2, scale.value + 0.1); // 最大放大到2倍
      }
    };
    var zoomOut = () => {
      if (scale.value > 0.5) {
        scale.value = Math.max(0.5, scale.value - 0.1); // 最小缩小到0.5倍
      }
    };
    var resetZoom = () => {
      scale.value = 1; // 重置为原始大小
    };
    var onPdfLoaded = pdf => {
      console.log({
        pdf
      });
      totalPages.value = pdf.numPages;
    };
    var prevPage = () => {
      if (currentPage.value > 1) currentPage.value--;
    };
    var nextPage = () => {
      if (currentPage.value < totalPages.value) currentPage.value++;
    };

    // 图片预览相关
    var imagePreviewVisible = ref(false);
    var currentPreviewImage = ref("");
    var imagePreviewTitle = ref("");

    // 判断是否为当前文件类型
    var isCurrentFileType = types => {
      if (fileList.value.length > 0 && currentFileIndex.value < fileList.value.length) {
        var currentFileType = fileList.value[currentFileIndex.value].type;
        if (Array.isArray(types)) {
          return types.includes(currentFileType);
        }
        return currentFileType === types;
      }
      return false;
    };
    // Excel选项配置
    var excelOptions = computed(() => {
      if (fileList.value.length > 0 && currentFileIndex.value < fileList.value.length) {
        var currentFileType = fileList.value[currentFileIndex.value].type;
        // 对.xls文件启用xls选项
        if (currentFileType === "xls") {
          return {
            xls: true
          };
        }
      }
      return {};
    });
    // 当前文件URL
    var currentFileUrl = computed(() => {
      if (fileList.value.length > 0 && currentFileIndex.value < fileList.value.length) {
        return fileList.value[currentFileIndex.value].url;
      }
      return "";
    });
    watch(() => props.modelValue, val => {
      visible.value = val;
      if (val && props.file) {
        initFile();
      }
    });
    watch(visible, val => {
      emit("update:modelValue", val);
      if (!val) {
        reset();
      }
    });
    var initFile = () => {
      var _props$file;
      // 处理新的数据结构 {current: ..., list: [...]}
      if ((_props$file = props.file) !== null && _props$file !== void 0 && _props$file.list && Array.isArray(props.file.list)) {
        fileList.value = props.file.list.map(f => {
          var _f$response;
          var url = ((_f$response = f.response) === null || _f$response === void 0 ? void 0 : _f$response.data.file_url) || f.url || f.file_url;
          var fileName = f.file_name || f.name || f.file_original_name;
          return {
            url,
            fileName,
            type: (fileName === null || fileName === void 0 ? void 0 : fileName.split(".").pop().toLowerCase()) || ""
          };
        }).filter(f => f.url); // 过滤掉没有URL的文件

        // 找到当前文件的索引
        var currentIndex = fileList.value.findIndex(f => {
          var _props$file$current, _props$file$current2, _props$file$current3, _props$file$current4;
          return f.fileName === ((_props$file$current = props.file.current) === null || _props$file$current === void 0 ? void 0 : _props$file$current.file_name) && f.url === (((_props$file$current2 = props.file.current) === null || _props$file$current2 === void 0 || (_props$file$current2 = _props$file$current2.response) === null || _props$file$current2 === void 0 ? void 0 : _props$file$current2.data.file_url) || ((_props$file$current3 = props.file.current) === null || _props$file$current3 === void 0 ? void 0 : _props$file$current3.url) || ((_props$file$current4 = props.file.current) === null || _props$file$current4 === void 0 ? void 0 : _props$file$current4.file_url));
        });
        console.log("currentIndex-->", currentIndex);
        currentFileIndex.value = currentIndex >= 0 ? currentIndex : 0;
      }
      // 如果传入的是数组，则为多文件模式
      else if (Array.isArray(props.file)) {
        fileList.value = props.file.map(f => {
          var _f$response2;
          var url = ((_f$response2 = f.response) === null || _f$response2 === void 0 ? void 0 : _f$response2.data.file_url) || f.url || f.file_url;
          var fileName = f.file_name || f.name || f.file_original_name;
          return {
            url,
            fileName,
            type: (fileName === null || fileName === void 0 ? void 0 : fileName.split(".").pop().toLowerCase()) || ""
          };
        }).filter(f => f.url); // 过滤掉没有URL的文件

        currentFileIndex.value = 0;
      } else {
        var _file$response;
        // 单文件模式
        var file = props.file;
        var url = ((_file$response = file.response) === null || _file$response === void 0 ? void 0 : _file$response.data.file_url) || file.url || file.file_url;
        var fileName = file.file_name || file.name;
        fileList.value = [{
          url,
          fileName,
          type: (fileName === null || fileName === void 0 ? void 0 : fileName.split(".").pop().toLowerCase()) || ""
        }];
        currentFileIndex.value = 0;
      }
      loading.value = false;
    };
    var onRendered = () => {
      loading.value = false;
    };

    // 专门为Excel组件添加的渲染完成回调
    var onExcelRendered = () => {
      loading.value = false;
      console.log("Excel文件渲染完成");
    };
    var onError = error => {
      loading.value = false;
      ElMessage({
        type: "error",
        message: "文件预览失败: " + (error.message || "未知错误")
      });
      console.error("Excel预览错误:", error);
    };
    var closeDialog = () => {
      visible.value = false;
    };
    var reset = () => {
      fileList.value = [];
      currentFileIndex.value = 0;
      loading.value = false;
    };
    var handlePreview = url => {
      if (url) {
        ElMessage({
          type: "success",
          message: "正在导出，请稍候"
        });
        var eleLink = document.createElement("a");
        eleLink.href = url;
        eleLink.target = "_blank";
        document.body.appendChild(eleLink);
        eleLink.click();
        document.body.removeChild(eleLink);
      } else {
        ElMessage.warning("无法预览该文件");
      }
    };

    // 上一个文件
    var prevFile = () => {
      if (currentFileIndex.value > 0) {
        currentFileIndex.value--;
      }
    };

    // 下一个文件
    var nextFile = () => {
      if (currentFileIndex.value < fileList.value.length - 1) {
        currentFileIndex.value++;
      }
    };

    // 打印文件
    var printFile = () => {
      var currentFileType = fileList.value[currentFileIndex.value].type;
      var fileUrl = currentFileUrl.value;
      if (!fileUrl) {
        ElMessage.warning("无法打印该文件");
        return;
      }
      if (["jpg", "jpeg", "png", "gif", "bmp", "jfif"].includes(currentFileType)) {
        // 打印图片
        printImage(fileUrl);
      } else if (currentFileType === "pdf") {
        // 打印PDF
        printPdf(fileUrl);
      } else {
        ElMessage.warning("该文件类型不支持打印");
      }
    };

    // 打印图片
    var printImage = imageUrl => {
      var printWindow = window.open("", "_blank");
      printWindow.document.write("\n    <html>\n      <head>\n        <title>\u6253\u5370\u56FE\u7247</title>\n        <style>\n          @media print {\n            @page {\n              margin: 0mm;\n              size: auto;\n            }\n            \n            body {\n              margin: 0;\n              padding: 0;\n              height: 100vh;\n              width: 100vw;\n              line-height: 0;\n            }\n            \n            .print-container {\n              width: 100%;\n              height: 100%;\n              display: flex;\n              justify-content: center;\n              align-items: center;\n              page-break-after: avoid;\n              page-break-before: avoid;\n              page-break-inside: avoid;\n            }\n            \n            img {\n              max-width: 100% !important;\n              max-height: 100vh !important;\n              width: auto !important;\n              height: auto !important;\n              display: block !important;\n              object-fit: contain;\n              page-break-after: avoid;\n              page-break-before: avoid;\n              page-break-inside: avoid;\n            }\n          }\n          \n          @media screen {\n            body {\n              margin: 0;\n              padding: 20px;\n              display: flex;\n              justify-content: center;\n              align-items: center;\n              min-height: 100vh;\n              background: #f5f5f5;\n            }\n            \n            .print-container {\n              width: 100%;\n              display: flex;\n              justify-content: center;\n              align-items: center;\n            }\n            \n            img {\n              max-width: 100%;\n              max-height: 90vh;\n              box-shadow: 0 0 10px rgba(0,0,0,0.1);\n            }\n          }\n        </style>\n      </head>\n      <body>\n        <div class=\"print-container\">\n          <img src=\"".concat(imageUrl, "\" onerror=\"window.close();\" onload=\"setTimeout(() => { \n            if (!this.complete) {\n              window.close();\n              return;\n            }\n            window.focus();\n            window.print(); \n          }, 500);\" />\n        </div>\n      </body>\n    </html>\n  "));
      printWindow.document.close();
    };

    // 打印PDF
    var printPdf = pdfUrl => {
      var printWindow = window.open("", "_blank");
      printWindow.document.write("\n    <html>\n      <head>\n        <title>\u6253\u5370PDF</title>\n        <style>\n          body {\n            margin: 0;\n            padding: 0;\n            background: #f5f5f5;\n          }\n          iframe {\n            width: 100%;\n            height: 100vh;\n            border: none;\n          }\n        </style>\n      </head>\n      <body>\n        <iframe src=\"".concat(pdfUrl, "\" onload=\"this.contentWindow.print();\"></iframe>\n      </body>\n    </html>\n  "));
      printWindow.document.close();
    };

    // 点击图片时切换到下一张（如果有）
    var handleImageClick = () => {
      if (fileList.value.length > 1) {
        nextFile();
      }
    };

    // 组件卸载时清理
    onUnmounted(() => {
      reset();
    });
    return (_ctx, _cache) => {
      var _component_el_button = _resolveComponent("el-button");
      var _component_el_dialog = _resolveComponent("el-dialog");
      return _openBlock(), _createElementBlock(_Fragment, null, [_createVNode(_component_el_dialog, {
        modelValue: visible.value,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => visible.value = $event),
        title: __props.title,
        width: "80%",
        height: "80%",
        onClose: closeDialog,
        "destroy-on-close": ""
      }, {
        footer: _withCtx(() => [_createElementVNode("div", _hoisted_12, [fileList.value.length > 1 ? (_openBlock(), _createElementBlock("div", _hoisted_13, [_createVNode(_component_el_button, {
          circle: "",
          size: "small",
          icon: "ArrowLeft",
          onClick: prevFile,
          disabled: currentFileIndex.value <= 0
        }, null, 8, ["disabled"]), _createElementVNode("span", _hoisted_14, _toDisplayString(currentFileIndex.value + 1) + " / " + _toDisplayString(fileList.value.length), 1), _createVNode(_component_el_button, {
          circle: "",
          size: "small",
          icon: "ArrowRight",
          onClick: nextFile,
          disabled: currentFileIndex.value >= fileList.value.length - 1
        }, null, 8, ["disabled"])])) : _createCommentVNode("", true), isCurrentFileType(['pdf', 'jpg', 'jpeg', 'png', 'gif', 'bmp', 'jfif']) ? (_openBlock(), _createBlock(_component_el_button, {
          key: 1,
          onClick: printFile,
          type: "primary"
        }, {
          default: _withCtx(() => _cache[13] || (_cache[13] = [_createTextVNode("打印")])),
          _: 1
        })) : isCurrentFileType(['xls', 'xlsx', 'docx']) ? (_openBlock(), _createBlock(_component_el_button, {
          key: 2,
          onClick: _cache[1] || (_cache[1] = $event => handlePreview(currentFileUrl.value)),
          type: "primary"
        }, {
          default: _withCtx(() => _cache[14] || (_cache[14] = [_createTextVNode("下载")])),
          _: 1
        })) : _createCommentVNode("", true), _createVNode(_component_el_button, {
          onClick: closeDialog
        }, {
          default: _withCtx(() => _cache[15] || (_cache[15] = [_createTextVNode("关闭")])),
          _: 1
        })])]),
        default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [isCurrentFileType(['pdf', 'docx', 'xls', 'xlsx', 'jpg', 'jpeg', 'png', 'gif', 'bmp', 'jfif']) ? (_openBlock(), _createElementBlock("div", _hoisted_2, [_createVNode(_component_el_button, {
          size: "small",
          type: "primary",
          onClick: zoomOut,
          disabled: scale.value <= 0.5
        }, {
          default: _withCtx(() => _cache[5] || (_cache[5] = [_createTextVNode("缩小")])),
          _: 1
        }, 8, ["disabled"]), _createElementVNode("span", _hoisted_3, _toDisplayString(Math.round(scale.value * 100)) + "%", 1), _createVNode(_component_el_button, {
          size: "small",
          type: "primary",
          onClick: zoomIn,
          disabled: scale.value >= 2
        }, {
          default: _withCtx(() => _cache[6] || (_cache[6] = [_createTextVNode("放大")])),
          _: 1
        }, 8, ["disabled"]), _createVNode(_component_el_button, {
          size: "small",
          onClick: resetZoom
        }, {
          default: _withCtx(() => _cache[7] || (_cache[7] = [_createTextVNode("重置")])),
          _: 1
        })])) : _createCommentVNode("", true), _createElementVNode("div", {
          class: "pdf-transform-wrapper",
          style: _normalizeStyle({
            transform: "scale(".concat(scale.value, ")"),
            transformOrigin: 'top center',
            marginBottom: '10px'
          })
        }, [isCurrentFileType('pdf') ? (_openBlock(), _createElementBlock("div", _hoisted_4, [_createVNode(_unref(VuePdfEmbed), {
          onLoaded: onPdfLoaded,
          page: currentPage.value,
          source: {
            url: currentFileUrl.value,
            cMapUrl: 'https://unpkg.com/pdfjs-dist/cmaps/',
            cMapPacked: true
          }
        }, null, 8, ["page", "source"]), totalPages.value > 1 ? (_openBlock(), _createElementBlock("div", _hoisted_5, [_createVNode(_component_el_button, {
          size: "small",
          type: "primary",
          onClick: prevPage,
          disabled: currentPage.value <= 1
        }, {
          default: _withCtx(() => _cache[8] || (_cache[8] = [_createTextVNode("上一页")])),
          _: 1
        }, 8, ["disabled"]), _createElementVNode("span", _hoisted_6, _toDisplayString(currentPage.value) + " / " + _toDisplayString(totalPages.value), 1), _createVNode(_component_el_button, {
          size: "small",
          onClick: nextPage,
          type: "primary",
          disabled: currentPage.value >= totalPages.value
        }, {
          default: _withCtx(() => _cache[9] || (_cache[9] = [_createTextVNode("下一页")])),
          _: 1
        }, 8, ["disabled"])])) : _createCommentVNode("", true)])) : isCurrentFileType(['docx']) ? (_openBlock(), _createBlock(_unref(VueOfficeDocx), {
          key: 1,
          src: currentFileUrl.value,
          style: {
            "width": "100%",
            "height": "100%"
          },
          onRendered: onRendered,
          onError: onError
        }, null, 8, ["src"])) : isCurrentFileType(['xls', 'xlsx']) ? (_openBlock(), _createElementBlock("div", _hoisted_7, [_createVNode(_unref(VueOfficeExcel), {
          src: currentFileUrl.value,
          options: excelOptions.value,
          class: "excel-preview-component",
          onRendered: onExcelRendered,
          onError: onError
        }, null, 8, ["src", "options"])])) : isCurrentFileType(['jpg', 'jpeg', 'png', 'gif', 'bmp', 'jfif']) ? (_openBlock(), _createElementBlock("div", _hoisted_8, [_createElementVNode("img", {
          src: currentFileUrl.value,
          style: {
            "max-width": "100%",
            "max-height": "100%",
            "display": "block"
          },
          onClick: handleImageClick
        }, null, 8, _hoisted_9)])) : (_openBlock(), _createElementBlock("div", _hoisted_10, [_cache[11] || (_cache[11] = _createElementVNode("p", {
          style: {
            "padding-bottom": "20px"
          }
        }, "该文件类型暂不支持在线预览。", -1)), _createVNode(_component_el_button, {
          onClick: _cache[0] || (_cache[0] = $event => handlePreview(currentFileUrl.value)),
          type: "primary"
        }, {
          default: _withCtx(() => _cache[10] || (_cache[10] = [_createTextVNode(" 下载文件 ")])),
          _: 1
        })]))], 4), loading.value ? (_openBlock(), _createElementBlock("div", _hoisted_11, _cache[12] || (_cache[12] = [_createElementVNode("p", null, "文件加载中...", -1)]))) : _createCommentVNode("", true)])]),
        _: 1
      }, 8, ["modelValue", "title"]), _createVNode(_component_el_dialog, {
        modelValue: imagePreviewVisible.value,
        "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => imagePreviewVisible.value = $event),
        title: imagePreviewTitle.value,
        width: "80%",
        height: "80%"
      }, {
        footer: _withCtx(() => [_createVNode(_component_el_button, {
          onClick: _cache[3] || (_cache[3] = $event => imagePreviewVisible.value = false)
        }, {
          default: _withCtx(() => _cache[16] || (_cache[16] = [_createTextVNode("关闭")])),
          _: 1
        })]),
        default: _withCtx(() => [_createElementVNode("div", _hoisted_15, [_createElementVNode("img", {
          src: currentPreviewImage.value,
          style: {
            "max-width": "100%",
            "max-height": "70vh"
          }
        }, null, 8, _hoisted_16)])]),
        _: 1
      }, 8, ["modelValue", "title"])], 64);
    };
  }
};